function getValidationErrorInEmail(enteredMail) {
    if ( !enteredMail ) {
        return;
    }

    const isContainSpace = enteredMail.includes(" ");
    const isContainSpecialSymbolLess = enteredMail.includes("<");
    const isContainSpecialSymbolMore = enteredMail.includes(">");

    if ( isContainSpace ) {
        return "email_contain_spaces";
    }

    if ( isContainSpecialSymbolLess || isContainSpecialSymbolMore ) {
        return "email_contain_special_character";
    }
}

export {getValidationErrorInEmail};
